import { render, staticRenderFns } from "./receiveTransferForm.vue?vue&type=template&id=dde3e962&"
import script from "./receiveTransferForm.vue?vue&type=script&lang=js&"
export * from "./receiveTransferForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports